import { FeedbackSearchParam } from "../searchParams/feedbackSearchParam.ts";
import FormatDate from "./formatDate.ts";
import GenerateQuery from "./generateQuery.ts";

const GenerateFeedbacksQuery = (searchParam: FeedbackSearchParam) => {
    let query = GenerateQuery(searchParam);
    if (query.length == 0) query = '?';

    if (searchParam.userID != null && searchParam.userID != 0)
        query += `userID=${encodeURIComponent(searchParam.userID!)}&`;
    if (searchParam.relationID != null && searchParam.relationID != 0)
        query += `relationID=${encodeURIComponent(searchParam.relationID!)}&`;
    if (searchParam.isSolved != null)
        query += `isSolved=${encodeURIComponent(searchParam.isSolved!)}&`;
    if (searchParam.isSolved != null)
        query += `isSolved=${encodeURIComponent(searchParam.isSolved!)}&`;
    if (searchParam.isSolved != null)
        query += `isSolved=${encodeURIComponent(searchParam.isSolved!)}&`;
    if (searchParam.dateFrom != null)
        query += `dateFrom=${FormatDate(searchParam.dateFrom)}&`;
    if (searchParam.dateTo != null)
        query += `dateTo=${FormatDate(searchParam.dateTo)}&`;

    if (query == '?')
        return '';

    return query;
}
export default GenerateFeedbacksQuery;